const setArtist = (state = "", action) => {
  switch (action.type) {
    case "SETARTIST":
      return action.payload;
    default:
      return state;
  }
};

export default setArtist;
